import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  ExDialog, ExButton, ButtonFlavor, ButtonType, ButtonSize,
  DialogHeaderContent,
  DialogVariant,
} from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import './SaveConfirmationDialog.scss';
import { useBoomiAgentFoundationContext } from '@context/BoomiAgentFoundationContext';

function SaveConfirmationDialog({
  handleCancel,
  handleExit,
  handleClose,
  isSaveDisabled,
}: any) {
  const { setCreateAgentMethod } = useBoomiAgentFoundationContext();
  const [t] = useTranslation('common');
  const dialogTitle = 'Save?';
  const confirmButtonText = 'Save and Close';
  const location = useLocation();
  function performSelectedAction() {
    handleExit();
  }
  function getMessage() {
    if (location.pathname.startsWith('/agent-designer')) {
      return t('agent_builder_close_without_save_confirmation_message');
    }
    if (location.pathname.startsWith('/add-acp-source')) {
      // Check if we're in edit mode for ACP sources
      const isAcpEditMode = location.search.includes('source=');
      return isAcpEditMode
        ? t('acp_source_edit_close_without_save_confirmation_message')
        : t('acp_source_create_close_without_save_confirmation_message');
    }
    if (location.pathname.startsWith('/add-source')) {
      return t('source_builder_close_without_save_confirmation_message');
    }
    return t('tool_builder_close_without_save_confirmation_message');
  }
  return (
    <ExDialog
      dialogTitle={dialogTitle}
      open
      hideClose={false}
      staticBackdrop
      headerContent={DialogHeaderContent.WARNING}
      onCancel={handleClose}
      variant={DialogVariant.SPACED}
    >
      <div className="confirmation-container" style={{ width: '480px' }}>
        {getMessage()}
      </div>
      <ExButton
        type={ButtonType.SECONDARY}
        size={ButtonSize.DEFAULT}
        flavor={ButtonFlavor.BASE}
        onClick={() => {
          setCreateAgentMethod('');
          handleCancel();
        }}
        slot="footer"
      >
        {t('agent_discard_changes')}
      </ExButton>
      <ExButton
        type={ButtonType.PRIMARY}
        size={ButtonSize.DEFAULT}
        flavor={ButtonFlavor.BASE}
        onClick={() => {
          performSelectedAction();
        }}
        slot="footer"
        disabled={isSaveDisabled()}
      >
        {confirmButtonText}
      </ExButton>
    </ExDialog>
  );
}

export default SaveConfirmationDialog;
